import {
  BillingTransactionStatus,
  BillingTransactionType,
} from "@/types/billing-transactions";

export type BillingLikeTransaction = {
  amount: number;
  currency?: string;
  type?: string | null;
  status?: string | null;
};

export interface BillingBalanceStats {
  currency: string;
  debetMinor: number;
  creditMinor: number;
  balanceMinor: number;
}

export const computeBillingBalanceStats = (
  transactions: BillingLikeTransaction[] = [],
): BillingBalanceStats => {
  const currency = transactions[0]?.currency ?? "USD";

  const payments = transactions.filter(
    (transaction) => transaction.type === BillingTransactionType.PAYMENT,
  );

  const paidPayments = payments.filter(
    (transaction) => transaction.status === BillingTransactionStatus.SUCCEEDED,
  );

  const notPaidPayments = payments.filter(
    (transaction) => transaction.status !== BillingTransactionStatus.SUCCEEDED,
  );

  const creditMinor = paidPayments.reduce(
    (sum, transaction) => sum + transaction.amount,
    0,
  );
  const debetMinor = notPaidPayments.reduce(
    (sum, transaction) => sum + transaction.amount,
    0,
  );

  return {
    currency,
    debetMinor,
    creditMinor,
    balanceMinor: creditMinor - debetMinor,
  };
};

export const formatMinorCurrency = (
  amountMinor = 0,
  currency = "USD",
): string =>
  (amountMinor / 100).toLocaleString("en-US", {
    style: "currency",
    currency,
  });
